import React from 'react'
import PromoList from '../promo_components/promo_list'

export default function Main() {
  return (
    <div className=''>
      <PromoList />
    </div>
  )
}
